import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\laragon\\www\\agrotechnusa\\node_modules\\.pnpm\\next@15.1.11_@babel+core@7._ff510c74a24b0a2dc9baf3ceca00ad78\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\components\\ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\components\\FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\components\\HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\components\\NewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\components\\OperationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\components\\ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\components\\StickyCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\components\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\laragon\\www\\agrotechnusa\\src\\components\\ui\\AppImage.tsx");
